<template>
	<v-container theme="light" style="background-color: #ffffff">
		<div class="dashboardriskdisplay">
			<v-col cols="5.5" xl="4" lg="6" md="8" sm="8" xs="12" class="riskpointdashboard">
				<v-col class="createriskdashboard" style="margin-top: -80px;">
					<v-select
						:items="matrixes"
						v-model="selectedItem"
						label="Select a Matrix"
						dense
						outlined
						style="position: relative; top: 110px; margin-right: 200px; padding-left: 100px;"
						@change="logSelectedItemId"
					></v-select>
					<div
						class="risk-chart-wrapper"
						style="margin-left: 30px; margin-top: 30px;"
					>
						<v-col style="margin-bottom: -65px;">
							<RiskmatrixChart :offsetValue="-0.5" :onlyRedRisks="true"/>
							<div class="horizontal-text">Probability</div>
						</v-col>
					</div>
					<!-- <v-btn
						class="createriskbtn"
						elevation="0"
						style="color: white; background-color: orange; padding: 5px; margin-bottom: 100px;"
						@click="navigateToRiskPage"
						>Create a Risk Matrix</v-btn
					> -->
				</v-col>
			</v-col>
			<v-col cols="6" xl="4" lg="6" md="8" sm="8" xs="12" class="scoredashboardfull">
				<v-col class="riskscoredashboard">
					<v-row class="riskscoreyourname">
						<v-col cols="10" class="avg">
							<supplier-csr
								:score1="score1"
								:score2="score2"
								:score3="score3"
								:score4="score4"
								:title="`Company Sustainability Score`"
							/>
						</v-col>
					</v-row>

					<v-col class="darkColor--text1" style="margin-top: 40px;">
						<v-btn
							:disabled="!showFillOutButton"
							class="yourscorebtn"
							elevation="0"
							style="color: white; background-color: orange;  padding: 5px;"
							exact
							@click="goToSuppliers"
							>{{ buttonText }}</v-btn
						>
						<h3 style="margin-top: -112px; margin-left: 150px;">
							Filled out : {{ this.filledoutdate }}
						</h3>
					</v-col>
				</v-col>
				<v-col class="riskaveragescoredashboard">
					<v-row class="riskaveragescoreyourname">
						<v-col cols="8" class="avg1">
							<supplier-csr
								:score1="riskScore1"
								:score2="riskScore2"
								:score3="riskScore3"
								:score4="riskScore4"
								:title="`Average Sustainability Score Of Supply Chain`"
							/>
						</v-col>
					</v-row>

					<v-col class="darkColor--text1" style="margin-top: 40px;">
						<v-btn
							class="averagescorebtn"
							elevation="0"
							to="/csr/request"
							style="color: white; background-color: orange;  padding: 5px;"
							>Invite suppliers to fill out</v-btn
						>
					</v-col>
				</v-col>
			</v-col>
		</div>
	</v-container>
</template>

<script>
import LoadingState from "../consts/LoadingState"
import CsrAPI from "../api/csr/csr"
import SupplierAPI from "../api/csr/supplier"
import RiskmatrixChart from "../components/RiskmatrixChart.vue"
import { riskmatrixAPI } from "../api/csr/riskmatrix"

export default {
	data() {
		return {
			id: null,
			score1: null,
			score2: null,
			score3: null,
			score4: null,
			riskScore1: null,
			riskScore2: null,
			riskScore3: null,
			riskScore4: null,
			connections: null,
			items: [],
			selectedItem: null,
			matrixes: [],
			filledoutdate: "",
			timestamp: null,
			Resubmit: null,
			csrID:null
		}
	},
	components: {
		RiskmatrixChart,
	},
	computed: {
		showFillOutButton() {
			if (this.Resubmit === 1) {
				return true
			}

			if (this.timestamp) {
				//const oneYearInMillis = 365 * 24 * 60 * 60 * 1000
				const timestampDate = new Date(this.timestamp)
				console.log(new Date(Date.UTC(timestampDate.getFullYear()+1, 0, 1, 0, 0, 0)))
				const newTimestampDate = new Date(Date.UTC(timestampDate.getFullYear()+1, 0, 1, 0, 0, 0))
				const currentDate = new Date()
				if(newTimestampDate>timestampDate && currentDate>newTimestampDate){
					return true
				}else{
					return false
				}
				//return currentDate - timestampDate >= oneYearInMillis
			}

			return false
		},
		buttonText() {
			if (this.Resubmit === 1) {
				return "Fill Out again"
			}

			if (this.timestamp) {
				const currentYear = new Date().getFullYear()
				return `Fill Out for ${currentYear}`
			}

			return "Fill out now" // Default case, though it should be covered by the conditions above.
		},
	},
	mounted() {
		this.loadCsr()
		this.loadRisk()
		this.loadItems()
	},
	methods: {
		loadCsr() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			CsrAPI.getCSRForm().then((data) => {
				this.id = data.csrID

				CsrAPI.getCSRAssessment(this.id)
					.then((result) => {
						console.log("CSR",result[0])
						if (result[0].timestamp) {
							const date = new Date(result[0].timestamp)
							const month = date.toLocaleString("default", { month: "short" })
							const year = date.getFullYear()
							this.filledoutdate = `${month} ${year}`
						}
						result
						this.score1 = Math.round(result[0].score1) || null
						this.score2 = Math.round(result[0].score2) || null
						this.score3 = Math.round(result[0].score3) || null
						this.score4 = Math.round(result[0].score4) || null
						this.timestamp = result[0].timestamp || null
						this.Resubmit = result[0].Resubmit || null
						this.csrID = result[0].id
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_END_LOADING,
							null,
							{ root: true }
						)
					})
					.catch((reason) => {
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_SET_ERROR,
							reason,
							{ root: true }
						)
					})
			})
		},
		loadRisk() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			SupplierAPI.getSuppliers()
				.then((data) => {
					this.connections = []
					for (let entry of data) {
						console.log(data)
						this.connections.push({
							clientID: entry.clientID,
							name: entry.name,
							csr: entry.csr,
							averageConnectionScores: entry.averageSupplierScores,
							remove: null,
						})
					}
					this.averageScore()
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		goToSuppliers() {
			this.$router.push({
				path: "/csr/resubmissions",
				query: { csrID: this.csrID, Resubmit: this.Resubmit },
			})
		},
		averageScore() {
			var size, score1, score2, score3, score4
			size = score1 = score2 = score3 = score4 = 0
			for (let connection of this.connections) {
				if (connection.csr) {
					size++
					score1 += connection.csr.score1
					score2 += connection.csr.score2
					score3 += connection.csr.score3
					score4 += connection.csr.score4
				}
			}

			this.riskScore1 = score1 / size
			this.riskScore2 = score2 / size
			this.riskScore3 = score3 / size
			this.riskScore4 = score4 / size
		},
		loadItems() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			riskmatrixAPI
				.getAll("Active")
				.then((data) => {
					this.items = data[0]
					console.log(data[0])
					// Sort the items by the 'Created' field in descending order
					this.items.sort((a, b) => new Date(b.Created) - new Date(a.Created))

					// Set the title of the item with the latest Created date as the selectedItem
					if (
						this.items.length > 0 &&
						this.$store.getters.selectedStatus == "Active" &&
						this.$store.getters.selectedId == null
					) {
						this.selectedItem = this.items[0].Title
						this.chooseChart(
							this.items[0].ID,
							this.items[0].Title,
							this.items[0].Description
						)
					} else if (
						this.items.length > 0 &&
						this.$store.getters.selectedStatus != "Active"
					) {
						this.selectedItem = this.items[0].Title
						this.chooseChart(
							this.items[0].ID,
							this.items[0].Title,
							this.items[0].Description
						)
					} else {
						this.selectedItem = this.$store.getters.selectedTitle
					}
					this.matrixes = this.items.map((item) => item.Title)
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		logSelectedItemId() {
			const selectedMatrix = this.items.find(
				(item) => item.Title === this.selectedItem
			)

			if (selectedMatrix) {
				this.chooseChart(
					selectedMatrix.ID,
					this.selectedItem,
					selectedMatrix.Description
				)
			} else {
				console.log("Selected item not found in the items array")
			}
		},
		chooseChart(ID, Title, Description) {
			this.$store.commit("setSelectedId", ID)
			this.$store.commit("setSelectedTitle", Title)
			this.$store.commit("setSelectedDescription", Description)
		},
		navigateToRiskPage() {
			this.$store.commit("setCreateMatrix", true)
			this.$router.push("/csr/riskmatrix/riskpage")
		},
	},
}
</script>

<style>
.dashboardriskdisplay {
	display: flex;
	margin-bottom: 50px;
}
.avg {
	margin-right: -20px;
}
.avg1 {
	margin-right: 20px;
}
.riskpointdashboard {
	display: flex;
	height: 550px;
	border: 1px solid #ddd;
	margin-top: 10px;
	border-radius: 10px;
	align-items: center;
	justify-self: center;
}

.scoredashboardfull {
	margin: -12px;
}

.riskscoredashboard {
	height: 270px;
	margin: 10px;
	border: 1px solid #ddd;
	padding: 0px;
	border-radius: 10px;
}

.darkColor--text1 {
	font-weight: bold;
	display: flex;
}

/* .createriskdashboard {} */

.createriskdashboard .risk-chart-wrapper {
	transform: scale(0.75);
}

.createriskdashboard .risk-chart-wrapper .divcolumn {
	margin-left: -150px !important;
}

.riskscoreyourname {
	padding: 0px;
	padding-left: 0px;
	margin-left: -190px;
	margin-top: -100px;
	transform: scale(0.5);
	width: max-content;
}

.riskscoreyourname .supplier-csr-wrapper {
	flex-wrap: inherit !important;
	margin-left: -200px;
	width: calc(100% + 448px);
}

.riskscoreyourname .supplier-csr-wrapper .flex-grow-0 {
	margin-right: 10px !important;
}

.riskscoreyourname .supplier-csr-header {
	justify-content: left !important;
}

.riskaveragescoredashboard {
	height: 270px;
	margin: 10px;
	border: 1px solid #ddd;
	padding: 0px;
	border-radius: 10px;
}

.riskaveragescoreyourname {
	padding: 0px;
	padding-left: 0px;
	margin-left: -190px;
	margin-top: -100px;
	transform: scale(0.5);
	width: max-content;
}

.riskaveragescoreyourname .supplier-csr-wrapper {
	flex-wrap: inherit !important;
	margin-left: -200px;
	width: calc(100% + 448px);
}

.riskaveragescoreyourname .supplier-csr-wrapper .flex-grow-0 {
	margin-right: 10px !important;
}

.riskaveragescoreyourname .supplier-csr-header {
	justify-content: left !important;
}

.yourscorebtn {
	margin-top: -115px;
	font-weight: bolder;
}

.averagescorebtn {
	margin-top: -115px;
	font-weight: bolder;
}

.createriskbtn {
	font-weight: bolder;
}
.horizontal-text {
	margin-top: 10px;
	margin-right: 0;
	margin-bottom: 10px;
	color: #217b7f;
	letter-spacing: 0.35em;
	font-weight: 700;
	font-size: 16px;
	text-align: center;
	white-space: nowrap;
}
@media (min-width: 1900px){
	.dashboardriskdisplay {
	display: flex;
	margin-bottom: 50px;
	justify-content: center;
	gap: 40px;
}
}
@media (min-width: 960px) and ( max-width: 1263px){
	.dashboardriskdisplay {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 50px;
		justify-content: center;
		gap: 40px;
	}
	.riskpointdashboard {
		display: flex;
		height: 550px;
		border: 1px solid #ddd;
		margin-top: 10px;
		margin-left: 22px;
		border-radius: 10px;
		align-items: center;
		justify-self: center;
	}
}
@media (max-width: 960px) {
	.dashboardriskdisplay {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 50px;
		justify-content: center;
		gap: 40px;
	}
	.riskpointdashboard {
		display: flex;
		height: 550px;
		border: 1px solid #ddd;
		margin-top: 10px;
		margin-left: 22px;
		border-radius: 10px;
		align-items: center;
		justify-self: center;
	}
	.createriskdashboard .risk-chart-wrapper {
		transform: scale(0.6);
	}

	.createriskdashboard .risk-chart-wrapper .divcolumn {
		margin-left: -150px !important;
	}
}
</style>
